export interface User {
  readonly id: number;
  readonly firstName: string;
  readonly lastName?: string;
  readonly email: string;
  completed?: boolean
}
export interface UserDetails {
  readonly id: number;
  readonly firstName: string;
  readonly lastName?: string;
  readonly isAdmin: boolean;
  readonly isDisplayApprovals: boolean;
  readonly roles: Role[];
}
export enum Role {
  ADMIN = 'ADMIN',
  USER = 'USER',
  APPROVING_MANAGER = 'APPROVING_MANAGER',
  PAYROLL_REPRESENTATIVE = 'PAYROLL_REPRESENTATIVE',
  ACCOUNTING_REPRESENTATIVE = 'ACCOUNTING_REPRESENTATIVE',
  BILLING_REPRESENTATIVE = 'BILLING_REPRESENTATIVE',
  FTEE_APPROVER_SELECTION = 'FTEE_APPROVER_SELECTION'
}
